import { render, staticRenderFns } from "./Commercial_terms.vue?vue&type=template&id=f46ced36&scoped=true&"
import script from "./Commercial_terms.vue?vue&type=script&lang=js&"
export * from "./Commercial_terms.vue?vue&type=script&lang=js&"
import style0 from "./Commercial_terms.vue?vue&type=style&index=0&id=f46ced36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ced36",
  null
  
)

export default component.exports